import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import InfoTooltip from '../InfoTooltip';

export const COMPLETION_FIELD_LABELS = {
  barcode: 'Código de barras', metricUnit: 'Unidad de venta',
  unitWeightKg: 'Peso por unidad (kg)', baseQuantityPerUnit: 'Equivalencia de inventario',
  sellingPrice: 'Precio de venta',
};

export const FormatCompletionNotice = ({ completion, onComplete, compact = false, pendingCount = 0 }) => {
  if (!pendingCount && (!completion || (completion.isReady && !completion.warnings?.length))) return null;
  const incomplete = completion && !completion.isReady;
  if (compact) {
    const message = [
      pendingCount > 0 && `${pendingCount} ${pendingCount === 1 ? 'cambio pendiente' : 'cambios pendientes'} en este formato.`,
      incomplete && (completion.isDraft ? 'Borrador · Datos incompletos.' : 'Datos incompletos.'),
      incomplete && `Falta: ${(completion.missingFields || []).map((field) => COMPLETION_FIELD_LABELS[field] || field).join(', ')}.`,
      completion?.warnings?.includes('barcode_conflict') && 'Este código de barras también se usa en otro formato.',
    ].filter(Boolean).join(' ');
    const icon = <FiAlertTriangle aria-hidden="true" className="h-3.5 w-3.5" />;
    const buttonClassName = 'inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-md border border-amber-300 bg-amber-50 text-amber-800 hover:bg-amber-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500';
    return onComplete
      ? <button type="button" onClick={onComplete} aria-label={`${pendingCount ? 'Revisar cambios pendientes' : 'Completar datos'}: ${message}`} title={message} className={buttonClassName}>{icon}</button>
      : <InfoTooltip message={message} label="Ver datos pendientes del formato" triggerClassName={buttonClassName}>{icon}</InfoTooltip>;
  }
  return <div className="mt-2 rounded-lg border border-amber-300 bg-amber-50 p-2 text-xs text-amber-950">
    {pendingCount > 0 && <p className="font-semibold">Cambios pendientes: {pendingCount}</p>}
    {incomplete && <>
      <p className="font-semibold">{completion.isDraft ? 'Borrador · Datos incompletos' : 'Datos incompletos'}</p>
      <p className="mt-1">Falta: {(completion.missingFields || []).map((field) => COMPLETION_FIELD_LABELS[field] || field).join(', ')}.</p>
    </>}
    {completion?.warnings?.includes('barcode_conflict') && <p>Este código de barras también se usa en otro formato.</p>}
    {onComplete && <button type="button" onClick={onComplete} className="mt-1 min-h-8 font-semibold underline">Completar datos</button>}
  </div>;
};
